/* eslint-disable react/destructuring-assignment */
import React from "react"
import { useSelector } from "react-redux"

import {
    StoreType,
    LangType,
} from "client/store"
import {
    HistoryProps,
    HistoryType,
    ComplianceHistory,
} from "client/components"
import {
    Answer,
    Bold,
} from "./styled"

export const HistoryAnswer = ({
    history,
}: HistoryProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const complianceHistory = history as ComplianceHistory
    let answer = complianceHistory.answer && complianceHistory.answer.trim()
    answer = answer && answer.length > 0 ? answer : null

    if (!answer) return null
    return (
        <Answer>
            <Bold>{`${lang.answer}:`}</Bold>
            {answer}
        </Answer>
    )
}

export const HistoryAnswerPdfExport = (
    history: HistoryType,
    lang: LangType,
) => {
    const complianceHistory = history as ComplianceHistory
    let answer = complianceHistory.answer && complianceHistory.answer.trim()
    answer = answer && answer.length > 0 ? answer : null

    if (!answer) return null
    return ({
        text: [
            {
                text: `${lang.answer}: `,
                bold: true,
            },
            { text: answer },
        ],
    })
}
